class BaseError extends Error {
  constructor(args: { code: string; message: string; userMessage: (t?: any) => string }) {
    super(args.message);
    this.name = this.constructor.name;
    this.code = args.code;
    this.userMessage = args.userMessage;
  }
  code: string;
  userMessage: (t?: any) => string;
}

export class UserNotFound extends BaseError {
  static CODE = 'USER_NOT_FOUND';
  constructor() {
    super({
      code: UserNotFound.CODE,
      message: 'User not found',
      userMessage: (t) => { if (t) { return t('errors.userNotFound') } else { return 'User not found' } },
    });
  }
}

export class AwaitingPayment extends Error {
  static CODE = 'AWAITING_PAYMENT';
  constructor() {
    super('Awaiting payment');
  }
}

export class UserFacingErrorMessage extends Error {
  static CODE = 'USER_FACING_ERROR';
  key: string;
  params: Record<string, any>;
  constructor(key: string, params?: Record<string, any>) {
    super("User facing error for key: " + key);
    this.name = 'UserFacingErrorMessage';
    this.key = key;
    this.params = params || {};
  }

  userMessage(t?: (key: string, params?: Record<string, any>) => string): string {
    if (t) {
      return t(this.key, this.params);
    }
    return this.key;
  }
}

type Translate = (key: string, params?: Record<string, any>) => string;

export function formatUserFacingError(error: unknown, t: Translate): string {
  if (error instanceof UserFacingErrorMessage) {
    return error.userMessage(t);
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}

export function isSignInRequiredError(error: unknown): boolean {
  if (!(error instanceof UserFacingErrorMessage)) return false;
  return error.key === 'errors.sign_in_required';
}
